/**
 * D1 sign-in copy: informational only (handbook §5). Native vs web differ
 * because MealMap web *is* the website; the phone app is not.
 */
export const SIGNIN_NEW_USER_COPY_NATIVE = 'New here? Create your account on the web.';
export const SIGNIN_NEW_USER_COPY_WEB = "New to Abbi's Way? Create your account here.";
export const SIGNIN_SIGNUP_LINK_LABEL = 'Create your account';
export const REQUEST_ACCOUNT_DELETION_LINK_LABEL = 'Request account deletion';
export const PRIVACY_POLICY_LINK_LABEL = 'Privacy policy';
